import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { LayersIcon, SaveAllIcon, SaveIcon, Search } from "lucide-react";
import { getProfileFromToken } from './config'; 
import MHeader from './header';
import Mfooter from './footer';
import config from "./config";
// --- Funzioni e config di ESEMPIO (decommenta le tue importazioni reali) ---

const customStyles = {
  control: (base) => ({
    ...base,
    width: "80%",  // Cambia larghezza
    minHeight: "40px", // Altezza minima
    fontSize: "16px",  // Dimensione testo
  }),
};
function AddLayer({ user }) {

  const navigate = useNavigate();

  // --- Logica di "guardia" (route guard) ---
  useEffect(() => {
    let profile = getProfileFromToken();
    if (profile !== "Admin") {
      navigate("/");
    }
  }, [navigate]);

  // --- Stato per i dati del Form ---
  const [luoghi, setLuoghi] = useState([]); // Per l'elenco nel <select>
  const [selectedLuogo, setSelectedLuogo] = useState(''); // L'ID del luogo scelto

  // Stato per la lista di layer da inviare
  const [layers, setLayers] = useState([]);
  
  // Stato per i campi di input del singolo layer
  const [nomeLayer, setNomeLayer] = useState('');
  const [linkLayer, setLinkLayer] = useState('');

  // --- Carica i luoghi al montaggio del componente ---
  useEffect(() => {
    
     fetch(config.apiUrl+"/luogo")
      .then((res) => res.json())
      .then((data) => setLuoghi(data))
      .catch((error) => console.error("Errore nel fetch dei luoghi:", error))
  }, []); // L'array vuoto [] significa "esegui solo al montaggio"

  // --- Funzione per aggiungere un layer alla lista (localmente) ---
  const handleAddLayer = () => {
    if (!nomeLayer || !linkLayer) {
      alert('Per favore, compila sia il nome che il link del layer.');
      return;
    }
    const newLayer = {
      nome_layer: nomeLayer,
      link_layer: linkLayer
    };
    setLayers([...layers, newLayer]); // Aggiunge il nuovo layer all'array
    // Pulisce i campi di input
    setNomeLayer('');
    setLinkLayer('');
  };

  // --- Funzione per inviare il form completo ---
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedLuogo) {
      alert("Seleziona un luogo prima di salvare.");
      return;
    }
    if (layers.length === 0) {
      alert("Aggiungi almeno un layer prima di salvare.");
      return;
    }

    const formData = new FormData();
    
    formData.append('id_luogo', ""+selectedLuogo.value);
    // Convertiamo l'array di oggetti layer in una stringa JSON
    // Il backend dovrà fare JSON.parse() di questo campo
    formData.append('layers', JSON.stringify(layers));

    try {
      const response = await fetch(config.apiUrl + '/newlayer', { // L'API che hai richiesto
        method: 'POST',
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        body: formData,
      });

      if (response.ok) {
        alert(`Layer aggiunti con successo!`);
        navigate("/");
      } else {
        alert('Errore durante il salvataggio dei layer.');
      }
    } catch (error) {
      console.error('Errore:', error);
      alert('Si è verificato un errore durante il salvataggio.');
    }
  };

  return (
    <div className="App">
      <h2 className="App-header">{config.appName}</h2>
      <MHeader />
      <p><small>utente: {user}</small></p>
      <div className="relative"></div>
      
      <h2>Aggiungi Layer a un Luogo</h2>
      
      {/* Il form principale invia tutto alla fine */}
      <form onSubmit={handleSubmit}>
        
        {/* 1. Selezione Luogo */}
        <div>
          <label>Seleziona Luogo:</label><p></p>
            <Select
            options={luoghi}
            value={selectedLuogo}
            onChange={setSelectedLuogo}
            placeholder="Seleziona un luogo..."
            isClearable
          />
        <Search styles={customStyles} size={1} />

   
        </div>

        {/* 2. Sezione per aggiungere i singoli layer (non invia il form) */}
        <div style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0', borderRadius: '8px' }}>
          <h4>Aggiungi Layer</h4>
          {/* Nome Layer */}
          <div>
            <label>Nome Layer:</label><p></p>
            <input
              type="text"
              value={nomeLayer}
              onChange={(e) => setNomeLayer(e.target.value)}
            />
          </div>
          {/* Link Layer */}
          <div>
            <label>Link Layer:</label><p></p>
            <input
              type="text"
              value={linkLayer}
              onChange={(e) => setLinkLayer(e.target.value)}
            />
          </div>
          {/* Bottone per aggiungere alla lista (type="button" per non inviare il form) */}
          <button type="button" onClick={handleAddLayer} style={{marginTop: '10px'}}>
            <LayersIcon className="mr-2" /><br/>Aggiungi Layer alla lista
          </button>
        </div>

        {/* 3. Elenco dei layer pronti per l'invio */}
        {layers.length > 0 && (
          <div>
            <h4>Layer da associare:</h4>
            <ul>
              {layers.map((layer, index) => (
                <li key={index}>
                  {layer.nome_layer} ({layer.link_layer})
                </li>
              ))}
            </ul>
          </div>
        )}
        
        {/* 4. Bottone di invio finale */}
        <button type="submit"><SaveAllIcon className="mr-2" /><br/>Salva e Associa Layer</button><p></p>
      </form>
      
      <Mfooter/>
    </div>
  );
}

export default AddLayer;
